import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { EditorComponent } from "@tinymce/tinymce-angular";

@Component({
  selector: 'html-editor',
  template:
    `
      <editor
        [init]="init"
        [formControl]="formControl"
      >
      </editor>

    <div *ngIf="showError" class="col-3 invalid-feedback d-block">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
    <br>
    `,
})
export class FormlyFieldHtmlEditor extends FieldType<FieldTypeConfig> {

  init: EditorComponent['init'] = {
    plugins: 'lists link image table code help wordcount',
    promotion: false,
    language_url: 'assets/langs/it.js', //https://www.tiny.cloud/get-tiny/language-packages/
    language: 'it',
  };

  ngOnInit() {
  }
}
